import type { GridApiPro, GridRowId } from '@mui/x-data-grid-pro';
import { MutableRefObject, useCallback, useState } from 'react';

type Column = {
  name: string;
};
type RowId = GridRowId | number | string;

// currently works only with badges (TagBadge)
export const useCellResizer = (
  apiRef: MutableRefObject<GridApiPro>,
  columns: Column[],
  minHeight = 52,
  extraHeight = 0,
) => {
  const [, setExpandedRow] = useState<RowId>();

  const onExpand = useCallback(
    async (id: RowId) => {
      const height = Math.max(
        minHeight,
        ...columns.map(({ name }) => {
          const cellElement = apiRef.current.getCellElement(id, name);
          if (cellElement) {
            const element = cellElement.firstElementChild?.firstElementChild;
            if (
              cellElement?.firstElementChild?.firstElementChild &&
              cellElement.firstElementChild.firstElementChild.localName !== 'div'
            ) {
              setTimeout(() => onExpand(id));
            }
            return Number(element ? element.clientHeight : 0) + extraHeight;
          }
          return 0;
        }),
      );
      apiRef.current.unstable_setRowHeight(id, height);
      setExpandedRow(id);
    },
    [apiRef, columns, extraHeight, minHeight],
  );

  const onCollapse = useCallback(() => {
    setExpandedRow((prevState) => {
      if (prevState) {
        apiRef.current.unstable_setRowHeight(prevState, minHeight);
      }
      return undefined;
    });
  }, [apiRef, minHeight]);

  return {
    onExpand,
    onCollapse,
  };
};
